import { createApi } from "@reduxjs/toolkit/query/react";
import { dynamicBaseQuery } from "../badRequestHandler/BadRequestHandler";

export const getVehicleApi = createApi({
  reducerPath: "getVehicleApi",
  baseQuery: dynamicBaseQuery,
  refetchOnMountOrArgChange: true,

  endpoints: (builder) => ({
    getAllVehicleData: builder.query({
      query: () => ({
        url: "v1/inventory/vehicle/",
        method: "GET",
      }),
    }),

    createVehicleData: builder.mutation({
      query: (body) => ({
        url: "v1/inventory/vehicle/",
        method: "POST",
        body,
      }),
    }),

    getAllModelData: builder.query({
      query: (args?: { page?: number; page_size?: number , brand: number }) => {
        const params = new URLSearchParams();
        if (args?.page) params.append('page', args.page.toString());
        if (args?.page_size) params.append('page_size', args.page_size.toString());
        if (args?.brand) params.append('brand', args.brand.toString());
        
        const queryString = params.toString();
        return {
          url: `v1/inventory/models/${queryString ? `?${queryString}` : ''}`,
          method: "GET",
        };
      },
    }),

    getIdModelData: builder.query({
      query: (brandId) => ({
        url: `v1/inventory/models/?brand=${brandId}`,
        method: "GET",
      }),
    }),

    createModelData: builder.mutation({
      query: (body) => ({
        url: "v1/inventory/models/",
        method: "POST",
        body,
      }),
    }),

    getAllBrandData: builder.query({
      query: (args?: { page?: number; page_size?: number }) => {
        const params = new URLSearchParams();
        if (args?.page) params.append('page', args.page.toString());
        if (args?.page_size) params.append('page_size', args.page_size.toString());
        
        const queryString = params.toString();
        return {
          url: `v1/inventory/brands/${queryString ? `?${queryString}` : ''}`,
          method: "GET",
        };
      },
    }),

    getBrandData: builder.query({
      query: () => ({
        url: `v1/inventory/brands/`,
        method: "GET",
      }),
    }),
    createBrandData: builder.mutation({
      query: (body) => ({
        url: "v1/inventory/brands/",
        method: "POST",
        body,
      }),
    }),

    updateBrandName: builder.mutation({
      query: ({ body, id }) => ({
        url: `v1/inventory/brands/${id}/`,
        method: "PATCH",
        body,
      }),
    }),

    updateFuelType: builder.mutation({
      query: ({ body, id }) => ({
        url: `v1/inventory/fuel-types/${id}/`,
        method: "PATCH",
        body,
      }),
    }),

    updateModel: builder.mutation({
      query: ({ body, id }) => ({
        url: `v1/inventory/models/${id}/`,
        method: "PATCH",
        body,
      }),
    }),

    getAllFuelTypeData: builder.query({
      query: (args?: { page?: number; page_size?: number }) => {
        const params = new URLSearchParams();
        if (args?.page) params.append('page', args.page.toString());
        if (args?.page_size) params.append('page_size', args.page_size.toString());
        
        const queryString = params.toString();
        return {
          url: `v1/inventory/fuel-types/${queryString ? `?${queryString}` : ''}`,
          method: "GET",
        };
      },
    }),

    createFuelTypeData: builder.mutation({
      query: (body) => ({
        url: "v1/inventory/fuel-types/",
        method: "POST",
        body,
      }),
    }),

    getAllServiceData: builder.query({
      query: (args?: { page?: number; page_size?: number }) => {
        const params = new URLSearchParams();
        if (args?.page) params.append('page', args.page.toString());
        if (args?.page_size) params.append('page_size', args.page_size.toString());
        
        const queryString = params.toString();
        return {
          url: `v1/inventory/service-types/${queryString ? `?${queryString}` : ''}`,
          method: "GET",
        };
      },
    }),

    getServiceData: builder.query({
      query: () => ({
        url: `v1/inventory/service-types/`,
        method: "GET",
      }),
    }),

    createServiceData: builder.mutation({
      query: (body) => ({
        url: "v1/inventory/service-types/",
        method: "POST",
        body,
      }),
    }),

    updateService: builder.mutation({
      query: ({ body, id }) => ({
        url: `v1/inventory/service-types/${id}/`,
        method: "PATCH",
        body,
      }),
    }),

    getAllSubServiceData: builder.query({
      query: (args?: { page?: number; page_size?: number }) => {
        const params = new URLSearchParams();
        if (args?.page) params.append('page', args.page.toString());
        if (args?.page_size) params.append('page_size', args.page_size.toString());
        
        const queryString = params.toString();
        return {
          url: `v1/inventory/sub-service-types/${queryString ? `?${queryString}` : ''}`,
          method: "GET",
        };
      },
    }),

    getSubServiceOnIdBasisData: builder.query({
      query: (id) => ({
        url: `v1/inventory/service-types/${id}/sub_services/`,
        method: "GET",
      }),
    }),

    createSubServiceData: builder.mutation({
      query: (body) => ({
        url: "v1/inventory/sub-service-types/",
        method: "POST",
        body,
      }),
    }),

    updateSubService: builder.mutation({
      query: ({ body, id }) => ({
        url: `v1/inventory/sub-service-types/${id}/`,
        method: "PATCH",
        body,
      }),
    }),

    createThemeData: builder.mutation({
      query: (body) => ({
        url: "v1/inventory/theme/",
        method: "POST",
        body,
      }),
    }),

    onboardWorkshop: builder.mutation({
      query: (body) => ({
        url: "v1/inventory/workshops/",
        method: "POST",
        body,
      }),
    }),

    updateWorkshop: builder.mutation({
      query: ({ id, body }) => ({
        url: `v1/inventory/workshops/${id}/`,
        method: "PATCH",
        body,
      }),
    }),

    getOnboardWorkshopData: builder.query({
      query: (currentPage) => {
        return {
          url: `v1/inventory/workshops/?page=${currentPage}`,
          method: "GET",
        };
      },
    }),

    updateOnboardWorkshopData: builder.mutation({
      query: ({ id, body }) => ({
        url: `v1/inventory/workshops/${id}/`,
        method: "PATCH",
        body,
      }),
    }),

    getCompleteOnboardWorkshopData: builder.query({
      query: (id) => ({
        url: `v1/inventory/workshops/${id}`,
        method: "GET",
      }),
    }),

    getThemeData: builder.query({
      query: () => ({
        url: "v1/inventory/theme/",
        method: "GET",
      }),
    }),

    deleteBrandInfo: builder.mutation({
      query: (id) => ({
        url: `v1/inventory/brands/${id?.id}/`,
        method: "DELETE",
      }),
    }),

    deleteModelInfo: builder.mutation({
      query: (id) => ({
        url: `v1/inventory/models/${id?.id}/`,
        method: "DELETE",
      }),
    }),

    deleteFuelTypeInfo: builder.mutation({
      query: (id) => ({
        url: `v1/inventory/fuel-types/${id?.id}/`,
        method: "DELETE",
      }),
    }),

    deleteServiceTypeInfo: builder.mutation({
      query: (id) => ({
        url: `v1/inventory/service-types/${id?.id}/`,
        method: "DELETE",
      }),
    }),

    deleteSubServiceTypeInfo: builder.mutation({
      query: (id) => ({
        url: `v1/inventory/sub-service-types/${id?.id}/`,
        method: "DELETE",
      }),
    }),

    getGeoLocation: builder.mutation({
      query: (body) => ({
        url: "v1/gc/geocoding/get_coordinates/",
        method: "POST",
        body,
      }),
    }),

    workshopAdminLogin: builder.mutation({
      query: (body) => ({
        url: "v1/gc/garage-login/",
        method: "POST",
        body,
      }),
    }),

    // Consent Master

    consentMaster: builder.query({
      query: () => ({
        url: "v1/gc/consent-masters/",
        method: "GET",
      }),
    }),

    createConsentMaster: builder.mutation({
      query: (body) => ({
        url: "v1/gc/consent-masters/",
        method: "POST",
        body,
      }),
    }),

    updateConsentMaster: builder.mutation({
      query: ({ id, body }) => ({
        url: `v1/gc/consent-masters/${id}/`,
        method: "PUT",
        body,
      }),
    }),

    getCustomerVehicle: builder.query({
      query: () => ({
        url: `/v1/gc/vehicles/`,
        method: "GET",
      }),
    }),

    getWorkshopNearBy: builder.mutation({
      query: (body) => ({
        url: `/v1/gc/garage-search/search/`,
        method: "POST",
        body,
      }),
    }),

    bookingRequest: builder.mutation({
      query: (body) => ({
        url: `v1/gc/booking-requests/`,
        method: "POST",
        body,
      }),
    }),

    allCustomerBookingRequest: builder.query({
      query: (id) => ({
        url: `v1/gc/booking-requests/?customer_id=${id}`,
        method: "GET",
      }),
    }),

    allWorkshopBookingRequest: builder.query({
      query: (id) => ({
        url: `v1/gc/booking-requests/?workshop_id=${id}`,
        method: "GET",
      }),
    }),

    cancelBookingRequest: builder.query({
      query: (id) => ({
        url: `v1/gc/booking-requests/${id}/cancel/`,
        method: "GET",
      }),
    }),

    banners: builder.query({
      query: (id) => ({
        url: `v1/gc/banners/`,
        method: "GET",
      }),
    }),

    uploadBanners: builder.mutation({
      query: (body) => ({
        url: `v1/gc/banners/`,
        method: "POST",
        body,
      }),
    }),

    updateBanners: builder.mutation({
      query: ({ body, id }) => ({
        url: `v1/gc/banners/${id}/`,
        method: "PATCH",
        body,
      }),
    }),

    deleteBanner: builder.mutation({
      query: (id) => ({
        url: `v1/gc/banners/${id}`,
        method: "DELETE",
      }),
    }),

    // Gallery media
    galleryMediaList: builder.query({
      query: (args?: { page?: number; page_size?: number }) => {
        const params = new URLSearchParams();
        if (args?.page) params.append("page", String(args.page));
        if (args?.page_size) params.append("page_size", String(args.page_size));
        const qs = params.toString();
        return {
          url: `v1/gc/gallery-media/list/${qs ? `?${qs}` : ""}`,
          method: "GET",
        };
      },
    }),

    createGalleryMedia: builder.mutation({
      query: (body) => ({
        url: `v1/gc/gallery-media/upload/`,
        method: "POST",
        body,
      }),
    }),


    updateGalleryMedia: builder.mutation({
      query: ({ body, id }: { body: any; id: number | string }) => ({
        url: `v1/gc/gallery-media/${id}/`,
        method: "PUT",
        body,
      }),
    }),

    deleteGalleryMedia: builder.mutation({
      query: (id: number | string) => ({
        url: `v1/gc/gallery-media/${id}`,
        method: "DELETE",
      }),
    }),
  }),
});

export const {
  useDeleteBannerMutation,
  useUpdateBannersMutation,
  useUploadBannersMutation,
  useBannersQuery,
  useBookingRequestMutation,
  useGetWorkshopNearByMutation,
  useGetCustomerVehicleQuery,
  useGetIdModelDataQuery,
  useUpdateConsentMasterMutation,
  useCreateConsentMasterMutation,
  useConsentMasterQuery,
  useWorkshopAdminLoginMutation,
  useUpdateOnboardWorkshopDataMutation,
  useGetGeoLocationMutation,
  useUpdateWorkshopMutation,
  useDeleteSubServiceTypeInfoMutation,
  useDeleteServiceTypeInfoMutation,
  useDeleteBrandInfoMutation,
  useDeleteFuelTypeInfoMutation,
  useDeleteModelInfoMutation,
  useGetOnboardWorkshopDataQuery,
  useGetCompleteOnboardWorkshopDataQuery,
  useOnboardWorkshopMutation,
  useGetThemeDataQuery,
  useCreateThemeDataMutation,
  useGetAllSubServiceDataQuery,
  useGetSubServiceOnIdBasisDataQuery,
  useCreateSubServiceDataMutation,
  useUpdateSubServiceMutation,
  useUpdateServiceMutation,
  useUpdateModelMutation,
  useUpdateFuelTypeMutation,
  useUpdateBrandNameMutation,
  useCreateFuelTypeDataMutation,
  useGetAllFuelTypeDataQuery,
  useCreateBrandDataMutation,
  useCreateModelDataMutation,
  useGetBrandDataQuery,
  useGetAllBrandDataQuery,
  useGetAllModelDataQuery,
  useCreateVehicleDataMutation,
  useGetAllVehicleDataQuery,
  useCreateServiceDataMutation,
  useGetAllServiceDataQuery,
  useGetServiceDataQuery,
  useGalleryMediaListQuery,
  useCreateGalleryMediaMutation,
  useDeleteGalleryMediaMutation,
  useUpdateGalleryMediaMutation,
} = getVehicleApi;
